__turbopack_context__.v({
  "barBorder": "wGrCwG_barBorder",
  "label": "wGrCwG_label",
  "progressBar": "wGrCwG_progressBar",
  "progressBar--DELIVERED": "wGrCwG_progressBar--DELIVERED",
  "progressBar--INIT": "wGrCwG_progressBar--INIT",
  "progressBar--PROCESSING": "wGrCwG_progressBar--PROCESSING",
  "pulse-1": "wGrCwG_pulse-1",
  "pulse-2": "wGrCwG_pulse-2",
  "pulse-3": "wGrCwG_pulse-3",
  "pulse1": "wGrCwG_pulse1",
  "pulse2": "wGrCwG_pulse2",
  "pulse3": "wGrCwG_pulse3",
});
